var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects-empty"},[_c('img',{attrs:{"src":require("@/assets/img/no-projects.svg"),"alt":"empty projects"}}),_c('div',{staticClass:"subtitle-2 text-center mt-6"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('div',{staticClass:"caption text-center mt-3",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }